export const SET_SCHEDULE_FREQUENCYS_LOADED = "SET_SCHEDULE_FREQUENCYS_LOADED";

export const setScheduleFrequenciesLoaded = (scheduleFrequenciesLoaded: boolean) => {
    return {
        scheduleFrequenciesLoaded,
        type: SET_SCHEDULE_FREQUENCYS_LOADED
    };
};
